var appWindowMinWidth = 400;
    var appWindowMinHeight = 200;

    module.exports = {
        props:{
            app:Object,
        },
        data: function () {
            return {
                drag:false,
                resize:{
                    r:false,
                    b:false,
                    t:false,
                    l:false
                },
                overlayShow:false,
                resizeDirection:['t','b','l','r','tl','tr','bl','br']
            }
        },
        computed:{
            isResizing:function () {
                var resizing = false;
                $.each(this.resize,function (k,v) {
                    if(v){
                        resizing = true;
                    }
                })
                return resizing;
            }
        },
        methods: {
            appWindowMousedown:function (app,e) {
                if( !$(e.target).is('.app-control *') ){
                    app.show();
                }
            },
            titleMousedown:function (app,e) {
                app.show();
                this.drag = {x:e.clientX-app.left,y:e.clientY-app.top};
            },
            mouseup:function () {
                this.drag = false;
                var vm = this;
                $.each(this.resize,function (k,v) {
                    vm.resize[k] = false;
                });
            },
            closeApp:function (app) {
                app.close();
            },
            maxApp:function (app) {
                app.maximize();
            },
            hideApp:function (app) {
                app.hide();
            },
            resizeHandler:function (direction,event) {
                var vm = this;
                var app = vm.app;
                app.show();
                var fn = {
                    r:function (e) {
                        vm.resize.r = {d:e.clientX-app.left-app.width};
                    },
                    b:function (e) {
                        vm.resize.b = {d:e.clientY-app.top-app.height};
                    },
                    l:function (e) {
                        vm.resize.l = {
                            d:e.clientX - app.left,      // distance of click and edge
                            right:app.left+app.width
                        };
                    },
                    t:function (e) {
                        vm.resize.t ={
                            d:e.clientY - app.top,
                            bottom:app.top + app.height
                        }
                    },
                };
                var arr = direction.split('');
                arr.forEach(function(dir){
                    if(fn[dir]){
                        fn[dir](event)
                    }
                })
            }
        },
        components: {},
        ready: function () {
            var vm = this;
            var $w = $(window);
            var app = vm.app;

            function isset(n){
                return typeof n !=='undefined';
            }

            function onDrag(e){
                var y = e.clientY - vm.drag.y;
                var x = e.clientX - vm.drag.x;
                app.top = Math.min(Math.max(0,y),window._h-app.height-app.titleHeight);
                app.left = Math.min(Math.max(0,x),window._w-app.width);
            }

            function onEasyResize(e){
                var height,width;

                if(vm.resize.b){
                    height = e.clientY - vm.resize.b.d - app.top;
                }

                if(vm.resize.r){
                    width = e.clientX - vm.resize.r.d - app.left;
                }

                if(height){
                    var maxHeight = window._h - app.top - app.titleHeight;
                    height = Math.max(Math.min(height,maxHeight),appWindowMinHeight);
                    app.set('height',height);
                }
                if(width){
                    var maxWidth = window._w - app.left;
                    width = Math.max(Math.min(width,maxWidth),appWindowMinWidth);
                    app.set('width',width);
                }
            }

            function onDamnItResize(e){
                var height,width,top,left,right,bottom;

                if(vm.resize.l){
                    right = vm.resize.l.right;
                    left = e.clientX - vm.resize.l.d;
                    left = Math.max(left,0);
                }
                if(vm.resize.t){
                    bottom = vm.resize.t.bottom;
                    top = e.clientY - vm.resize.t.d;
                    top = Math.max(top,0);
                }


                if(right && isset(left)){
                    width = right - left;
                    if(width<appWindowMinWidth){
                        width = appWindowMinWidth;
                        left = right - width;
                    }
                }

                if(isset(top) && bottom){
                    height = bottom - top;
                    if(height < appWindowMinHeight){
                        height = appWindowMinHeight;
                        top = bottom - height;
                    }
                }

                if(isset(left)){
                    app.set('left',left);
                }
                if(isset(top)){
                    app.set('top',top);
                }

                if(height){
                    app.set('height',height);
                }
                if(width){
                    app.set('width',width);
                }
            }

            $w.on('mousemove',function (e) {

                if(vm.drag){
                    onDrag(e);
                }else if(vm.isResizing){
                    onEasyResize(e);
                    onDamnItResize(e);
                }

            }).on('mouseup',vm.mouseup);
            
            vm.$watch(function () {
                return vm.drag || vm.isResizing;
            },function (val) {
                $event.emit('overlay:show',val);
            });
            $event.on('overlay:show',function (val) {
                vm.overlayShow = val;
            });

        }
    }

    // auto load apps in `../components/apps/`
    var appRequire = require.context('../components/apps/', true, /\.vue$/);
    var appPathArr = appRequire.keys();
    appPathArr.forEach(function (appPath) {
        var appName = appPath.match(/\.\/([a-z\-_]*)\.vue$/)[1].replace(/-(\w)/,function(match,match1){
            return match1.toUpperCase();
        });
        module.exports.components[appName] = appRequire(appPath);
    });


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/app-window.vue
 ** module id = 66
 ** module chunks = 0
 **/